// Remembers which store / branch a cashier last looked at. It is only a
// starting point: callers must re-check it against the stores and branches the
// user is currently allowed to reach before using it.
const KEY_PREFIX = "lud-cashier-selection:";

const keyFor = (userId) => `${KEY_PREFIX}${userId || "anon"}`;

export const readCashierSelection = (userId) => {
  try {
    const saved = JSON.parse(localStorage.getItem(keyFor(userId)) || "null");
    return {
      storeId: typeof saved?.storeId === "string" ? saved.storeId : "",
      branches: saved?.branches && typeof saved.branches === "object" ? saved.branches : {},
    };
  } catch {
    return { storeId: "", branches: {} };
  }
};

// `branchId` is remembered per store, so going back to a store restores its branch.
export const saveCashierSelection = (userId, { storeId, branchId }) => {
  if (!storeId) return;
  try {
    const current = readCashierSelection(userId);
    const branches = branchId ? { ...current.branches, [storeId]: branchId } : current.branches;
    localStorage.setItem(keyFor(userId), JSON.stringify({ storeId, branches }));
  } catch {
    // storage unavailable: the selection simply is not remembered
  }
};
